import { Renderer } from './renderer';
import { Message } from './message';
import { Lesson } from '../model/lesson';


@Renderer.register("lesson")
export class LessonRenderer extends Renderer {
    render(element: Lesson, context: object): Message {
        return new Message("lesson", {
            refid: element.refid,
            preventSkip: element.preventSkip,
        });
    }
}
